module.exports = __webpack_public_path__ + "img/card.972cd1b3.png";